var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite"},[_c('search'),(!_vm.logged)?_c('div',{staticClass:"section_content"},[_c('div',{staticClass:"no_login_msg"},[_vm._v(" پێویستە سەرەتا خۆت تۆمار بکەیت ")])]):_vm._e(),(_vm.logged)?_c('div',{staticClass:"section_content"},[_c('div',{staticClass:"no_login_msg"},[_vm._v(" هیچ شتێک بەردەست نییە ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }